package us.laantech.laanmanage.api

import kotlinx.browser.window

actual fun isRunningInDevEnv(): Boolean {
    val hostname = window.location.hostname
    println("hostname: $hostname")
    return hostname == "localhost" || hostname == "127.0.0.1"
}